
import React, { useState, useEffect } from 'react';
import { ensureNewGenomeProCookie } from './WebserverUser';
import logoDarkBg from '../../varxomics.png';
import logoLightBg from '../../varxomics_dark.png';
import baseLogo from '../../base_logo.png';
import baseLogoLight from '../../base_logo_light.png';
import './newgenome.css';

// Import modules
import Home from './modules/Home/Home.js';
import DataAccess from './modules/DataAccess/DataAccess.js';
import Documentation from './modules/Documentation/Documentation.js';
import Settings from './modules/Settings/Settings.js';
import Api from './modules/Api/Api.js';

function NewGenome() {
  const [cookieId, setCookieId] = useState('');
  const [daysLeft, setDaysLeft] = useState(0);
  const [activeTab, setActiveTab] = useState('home');
  const [theme, setTheme] = useState('dark'); // 'dark' or 'light'

  useEffect(() => {
    const cookie = ensureNewGenomeProCookie();
    if (cookie) {
      setCookieId(cookie.id);
      const diff = cookie.expiry - Date.now();
      const days = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
      setDaysLeft(days);
    }
  }, []);

  const toggleTheme = () => {
    setTheme(currentTheme => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home accountId={cookieId} onSettingsClick={() => setActiveTab('settings')} />;
      case 'data-access':
        return <DataAccess />;
      case 'documentation':
        return <Documentation />;
      case 'settings':
        return <Settings toggleTheme={toggleTheme} theme={theme} />;
      case 'api':
        return <Api cookieId={cookieId} />;
      default:
        return <Home accountId={cookieId} onSettingsClick={() => setActiveTab('settings')} />;
    }
  };

  const themeClass = theme === 'light' ? 'light-theme' : '';

  const logoSrc = theme === 'light' ? logoLightBg : logoDarkBg;
  const baseLogoSrc = theme === 'light' ? baseLogoLight : baseLogo;

  return (
    <div className={`WSNG-app-container ${themeClass}`}>
      <header className="WSNG-header">
        <div className="WSNG-header-left">
          <a href="/" className="WSNG-logo-container">
            <img src={baseLogoSrc} alt="Home" className="WSNG-logo" />
          </a>
          <nav className="WSNG-nav-tabs">
            <button
              className={`WSNG-nav-tab ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => setActiveTab('home')}
            >
              Home
            </button>
  
            <button
              className={`WSNG-nav-tab ${activeTab === 'settings' ? 'active' : ''}`}
              onClick={() => setActiveTab('settings')}
            >
              Settings
            </button>
            <button
              className={`WSNG-nav-tab ${activeTab === 'api' ? 'active' : ''}`}
              onClick={() => setActiveTab('api')}
            >
              API
            </button>
          </nav>
        </div>
      </header>

      <main className="WSNG-content-area">
        {renderContent()}
      </main>

         <div className="WSNG-cookie-icon">
          <i className="fas fa-cookie-bite"></i>
          <span className="WSNG-tooltip">{`ID: ${cookieId}\n${daysLeft} days left`}</span>
        </div>
    </div>
  );
}

export default NewGenome;
